export default __webpack_public_path__ + "static/media/multiwear.467c5b53.jpg";